import React from 'react';
import { BackButton, EditButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { NormalHeading } from '../../../../Components/Utils/Heading';
import NuDate from '../../../../Components/Utils/NuDate';

const ViewAppoinment = () => {
  const location = useLocation();
  const data = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  const leftDetails = [
    { label: "Title", value: data?.title },
    { label: "Holder Type", value: data?.holderType },
    { label: "Contact Person", value: data?.visitPurpose },
    { label: "Company Name", value: data?.visitPurpose },
    { label: "Location", value: data?.Location },
    { label: "Industry", value: data?.industry },
    { label: "Visit Purpose", value: data?.visitPurpose },
  ];

  const rightDetails = [
    { label: "Priority", value: data?.Priority },
    {
      label: "Appointment Date",
      value: data?.dateTime ? <NuDate value={data?.dateTime} format="DD-MMM-YYYY hh:mm a" /> : '-'
    },
    {
      label: "Reminder",
      value: data?.reminder ? <NuDate value={data?.reminder} format="DD-MMM-YYYY hh:mm a" /> : '-'
    },
    { label: "Status", value: data?.status },
    { label: "Comments", value: data?.comments },
  ];

  return (
    <div className="w-full h-full p-2 sm:px-4">
      {/* Top Header */}
      <div className="flex  justify-between items-center gap-3 mb-3">
        <Breadcrumb
          items={[
            // { name: "Marketing", link: "/marketing/appointments" },
            { name: "Appointment", link: "/marketing/appointments" },
            { name: "View" },
          ]}
        />
        <div className="flex items-center gap-2 self-end sm:self-auto">
          <Link
            to={'/marketing/appointments'}
            state={{ currentPage: pageIndex, searchQuery: searchQuery !== "" ? searchQuery : "" }}
          >
            <BackButton link={true} />
          </Link>
          {data?.appointmentId && (
            <Link
              to={`/marketing/appointments/edit/${data?.appointmentId}`}
              state={{ data: data, from: `/marketing/appointments/view/${data.appointmentId}` }}
            >
              <EditButton height="8" />
            </Link>
          )}
        </div>
      </div>

      {/* Responsive Content Container */}
      <div className="w-full mx-auto h-[calc(100vh-140px)] bg-white rounded-xl shadow-xs border border-slate-200/80 overflow-y-auto p-2 lgp-4">
        <div className="pb-3 border-b border-gray-100 mb-4">
          <NormalHeading title={"Appointment Detail"} />
        </div>

        <div className="flex flex-col lg:flex-row gap-6 w-full items-start">
          {/* Left Column */}
          <div className="w-full lg:w-1/2 flex flex-col gap-1">
            {leftDetails.map((item, idx) => (
              <div
                key={idx}
                className="odd:bg-white even:bg-slate-50/70 w-full flex items-center lg:px-3 py-2 rounded-lg text-xs sm:text-sm"
              >
                <p className="w-1/3 sm:w-2/5 font-semibold text-slate-700 shrink-0">
                  {item.label}
                </p>
                <p className="w-2/3 sm:w-3/5 text-slate-600 font-medium break-words pl-2">
                  {item.value || '-'}
                </p>
              </div>
            ))}
          </div>

          <div className="hidden lg:block w-[1px] bg-gray-200/80 self-stretch my-1" />

          {/* Right Column */}
          <div className="w-full lg:w-1/2 flex flex-col gap-1">
            {rightDetails.map((item, idx) => (
              <div
                key={idx}
                className="odd:bg-white even:bg-slate-50/70 w-full flex items-center px-3 py-2.5 rounded-lg text-xs sm:text-sm"
              >
                <p className="w-1/3 sm:w-2/5 font-semibold text-slate-700 shrink-0">
                  {item.label}
                </p>
                <p className="w-2/3 sm:w-3/5 text-slate-600 font-medium break-words pl-2">
                  {item.value || '-'}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAppoinment;